import {useEffect, useState} from 'react';
import {previewCookieName} from '~/lib/const';
import {getCookie} from '~/lib/utils';

/**
 * Maybe shows a notification about preview mode with a button that
 * exits preview mode by removing the cookie and reloading.
 */

export function ExitPreview() {
  const exitPreviewMode = () => {
    console.log('Remove preview cookie!');
    document.cookie =
      previewCookieName +
      '= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/ ';
    location.reload();
  };

  const [preview, setPreview] = useState(false);
  useEffect(() => {
    setPreview(!!getCookie(previewCookieName));
  });

  return preview ? (
    <div className="preview">
      Preview mode is active.{' '}
      <button className="underline" onClick={exitPreviewMode}>
        Exit preview
      </button>
    </div>
  ) : null;
}
